// eslint-disable-next-line eslint-comments/disable-enable-pair -- Ignore
/* eslint-disable react/no-array-index-key -- Ignore */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { SelectCustom, SelectCustomOption } from '@americanexpress/dls-react';
import clsx from 'clsx';
import { useRoomsContext } from '../../contexts/roomsContext';
import { useConfigContext } from '../../contexts/configContext';
import NotesSection from '../NotesSection/NotesSection';
import styles from './Infants.scss';
import { useChildAgeDropdowns } from '../../hooks/useChildAgeDropdowns';

const ChildrenAgesVariant = ({
  isMultiRoom,
  roomIndex,
}) => {
  const { rooms, updateChildAge } = useRoomsContext();
  const { moduleId } = useConfigContext();

  const { formatMessage } = useIntl();
  const { children } = rooms[roomIndex];

  const childAgeDropdownOptions = useChildAgeDropdowns();

  const roomId = roomIndex + 1;
  return (
    <div className="margin-1-b">
      <NotesSection id="child_age_at_end_of_travel" />
      <div className="row pad-1-lr">
        {children.map((age, childIndex) => {
          const childId = childIndex + 1;
          const labelHtmlFor = `${moduleId}-room-${roomId}-child-${childId}-age`;
          return (
            <div key={`${roomIndex}_${childIndex}`} className="col-xs-6 pad-0 pad-1-lr">
              <div className="form-group">
                <SelectCustom
                  id={labelHtmlFor}
                  status="default"
                  label={formatMessage({ id: 'child_age' },
                    { totalChildren: children.length, childIndex: childId })}
                  value={age}
                  onValueChange={(childAge) => updateChildAge(roomIndex, childIndex, childAge)}
                  aria-describedby="childAgeAtEndOfTravel"
                  className={clsx(styles.noWrapButton, 'margin-1-b')}
                >
                  {childAgeDropdownOptions.map((item) => (
                    <SelectCustomOption
                      aria-label={formatMessage(
                        { id: 'roomChildAgeAriaLabel' },
                        {
                          isMultiRoom,
                          roomId,
                          childId,
                          childAge: item.value,
                        }
                      )}
                      key={item.value}
                      value={item.value}
                      className="dls-bright-blue"
                    >
                      {item.label}
                    </SelectCustomOption>
                  ))}
                </SelectCustom>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

ChildrenAgesVariant.propTypes = {
  isMultiRoom: PropTypes.bool,
  roomIndex: PropTypes.number,
};

ChildrenAgesVariant.defaultProps = {
  roomIndex: 0,
};

export default ChildrenAgesVariant;
